import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import {
  Check,
  EmptyStateIllustrationOnboardingNotStarted
} from "@dreamhub/designsystem/icons";

interface Props {
  onCompleteOnboarding: () => void;
}

const OnboardingActiveNoStagesEmptyState: React.FC<Props> = ({
  onCompleteOnboarding
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-center w-full h-full min-h-[600px]"
      data-test="contract-detailed-view-onboarding-no-stages"
    >
      <div className="flex flex-col md:flex-row items-center gap-10 max-w-[760px]">
        <div className="flex-shrink-0">
          <EmptyStateIllustrationOnboardingNotStarted />
        </div>
        <div className="flex flex-col gap-6 max-w-[320px]">
          <div className="flex flex-col gap-5">
            <Text variant="lgSubtitleH1">
              {t("contracts.detailedView.onboarding.noStagesTitle")}
            </Text>
            <Text variant="lgBodySecondary">
              {t("contracts.detailedView.onboarding.noStagesDescription")}
            </Text>
          </div>
          <Button
            variant="secondary"
            className="h-9 px-[10px] w-fit gap-2"
            onClick={onCompleteOnboarding}
            data-test="contract-detailed-view-complete-onboarding-button"
          >
            <IconContainer size="5">
              <Check />
            </IconContainer>
            {t("contracts.detailedView.onboarding.completeOnboarding")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingActiveNoStagesEmptyState;
